import { createSelector } from '@ngrx/store';

import { RatingScalePresentation } from '@core/candidate-evaluation-settings-types';
import { createEntityCollectionStore } from '@core/ngrx-legacy';
import type { PickActions } from '@core/ngrx-legacy';
import type { RatingScalePresentationOption } from '@recruitee/candidate-evaluation-settings-types';

const idSelector = (scale: RatingScalePresentationOption) => scale.key;

const SELECTABLE_PRESENTATIONS = new Set<RatingScalePresentation>([
  RatingScalePresentation.Thumbs4,
  RatingScalePresentation.Thumbs5,
  RatingScalePresentation.Numeric,
]);

const { actions, reducer, namespace, selectors } =
  createEntityCollectionStore<RatingScalePresentationOption>()('CandidateEvaluationRatingScales', {
    idSelector,
    customActions: () => ({}),
  });

const RatingScalesActions: PickActions<typeof actions, 'fetchCollection'> = actions;

const RatingScalesSelectors = {
  ...selectors,
  defaultScaleOptions: createSelector(selectors.entities(), scales =>
    scales.filter(scale => SELECTABLE_PRESENTATIONS.has(scale.key)),
  ),
};

export {
  RatingScalesActions,
  RatingScalesSelectors,
  reducer as RatingScalesReducer,
  namespace as RatingScalesNamespace,
};
